import { t } from "i18next";

export default function getMilestoneDisplayName(milestoneName?: string | null) {
  if (!milestoneName) {
    return "";
  }
  if (milestoneName === "Anaesthesia Start") {
    return t("Anesthesia_Start");
  }
  return milestoneName;
}
